import {
  ApigetPlatformList,
  ApigetRealmanPage,
  ApigetBalance,
  ApitransferIn,
  ApitransferOut
} from '@api/service'
import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    //第三方平台列表
    platformList: [],
    //真人大厅列表
    // realmanHallList: [],
    //第三方平台余额列表
    platformBalanceList: [],
    // 棋牌
    chessPlatformCode: "",
    chessCurrenList: { list: [] },
    // 电子
    elePlatformCode: "",
    eleCurrenList: { list: [] },
    //电子是否支持捕鱼
    fishPlatformCode: "",
    supportFish: '',
    fishCurrenList: { list: [] },
  },
  mutations: {
    setplatformList(state, payload) {
      state.platformList = payload
    },
    // setrealmanHallList(state, payload) {
    //     state.realmanHallList = payload
    // },
    setplatformBalanceList(state, payload) {
      state.platformBalanceList = payload
    },
    updatePlatformBalance(state, payload) {
      let list = [...state.platformList];
      let index = list.findIndex(e => e.platformCode == payload.platformCode)
      list[index].balance = payload.balance;
      state.platformList = list;
    },
    updateChessPf(state, payload) {
      state.chessPlatformCode = payload;
    },
    setChessCurrenList(state, payload) {
      state.chessCurrenList = payload;
    },
    updateElectrPf(state, payload) {
      state.elePlatformCode = payload;
    },
    updateFishPf(state, payload) {
      state.fishPlatformCode = payload;
    },
    setEleCurrenList(state, payload) {
      state.eleCurrenList = payload;
    },
    setFishCurrenList(state, payload) {
      state.fishCurrenList = payload;
    },
    setSupportFish(state, payload) {
      state.supportFish = payload
    },
    updatePlatformLoading(state, data) {
      state.platformList = state.platformList.map(item => {
        if (item.platformCode === data.platformCode) {
          item.loading = data.loading
        }
        return item;
      })
    }
  },
  actions: {
    getPlatformList({ state, commit, dispatch }) {
      //获取平台列表 做个缓存
      return new Promise(async (resolve, reject) => {

        if (state.platformList.length != 0) {
          resolve(state.platformList)
          return;
        }

        let res = await ApigetPlatformList()
        if (res.code == '12200') {
          res.data.forEach(e => {
            e.balance = null
            e.loading = false
          })
          commit('setplatformList', res.data);
          resolve(res.data)
        }

      })

    },
    getRealmanHallList({ state, commit, dispatch }) {
      //获取真人大厅列表 做个缓存
      // return new Promise(async(resolve, reject) => {

      //     if (state.realmanHallList.length != 0) {
      //         resolve(state.realmanHallList)
      //         return;
      //     }

      //     let res = await ApigetRealmanPage({
      //         limit: 20
      //     })
      //     if (res.code == '12200') {
      //         res.data.list.forEach(e => {
      //             e.loading = false
      //         })
      //         commit('setrealmanHallList', res.data.list);
      //         resolve(res.data.list)
      //     }

      // })

    },
    getBalance({ state, commit }, platformCode) {
      //获取并更新某个平台的余额
      return new Promise(async (resolve, reject) => {

        let res = await ApigetBalance({ platformCode })

        if (res.code == '12200') {
          commit('updatePlatformBalance', {
            platformCode,
            balance: res.data
          })
          resolve(res.data)
          return;
        }
        resolve(0)

      })
    },
    walletTransinPlatform({ dispatch }, platformCode) {
      //全部从中心钱包转入到第三方平台
      return new Promise(async (resolve, reject) => {
        //先获取个人余额
        let amount = await dispatch('user/getBalance', '', { root: true });
        //将所有余额转入该平台
        let res = await ApitransferIn({
          platformCode,
          amount
        })
        if (res.code == '12200') {
          //更新个人余额 及 平台余额
          await dispatch('getBalance', platformCode)
          await dispatch('user/getBalance', '', { root: true });
          resolve(res);
          return;
        }
        reject(res)
      })
    },
    PlatformTransinWallet({ dispatch, commit }, platformCode) {
      //全部从第三方平台转入到中心钱包
      return new Promise(async (resolve, reject) => {
        let amount;
        try {
          //先获取该平台余额
          amount = await dispatch('getBalance', platformCode);
        } catch (e) {
          reject(e)
          return;
        }
        //将所有余额转出该平台
        let res = await ApitransferOut({
          platformCode,
          amount: Math.floor(amount)
        })
        if (res.code == '12200') {
          //更新个人余额 及 平台余额
          // commit('updatePlatformBalance', {
          //     platformCode,
          //     balance: 0
          // })
          await dispatch('getBalance', platformCode);
          await dispatch('user/getBalance', '', { root: true });
          resolve(res);
        }
        reject(res)
      })
    },
  },
  getters: {
    getEGamePlatformList(state, getters, rootState) {

      //筛选支持电子游戏平台

      let filterList = state.platformList.filter(platform => platform.isSupportElegame === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.elegameOrderNum - b.elegameOrderNum })

      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }
      return newList
    },
    getRealmanPlatformList(state, getters, rootState) {

      //筛选支持真人视讯平台
      let filterList = state.platformList.filter(platform => platform.isSupportRealman === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.realmanOrderNum - b.realmanOrderNum })

      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }

      return newList
    },
    getChessPlatformList: (state, getters, rootState) => {

      //筛选支持棋牌平台
      let filterList = state.platformList.filter(platform => platform.isSupportChess === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.chessOrderNum - b.chessOrderNum })

      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }

      return newList
    },
    getSportsPlatformList: (state, getters, rootState) => {

      //筛选支持体育平台
      let filterList = state.platformList.filter(platform => platform.isSupportSports === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.sportsOrderNum - b.sportsOrderNum })

      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }
      return newList
    },
    getDianjingPlatformList: (state, getters, rootState) => {

      //筛选支持电竞平台
      let filterList = state.platformList.filter(platform => platform.isSupportElesports === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.elesportsOrderNum - b.elesportsOrderNum })

      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }
      return newList
    },
    getFishPlatformList: (state, getters, rootState) => {
      //筛选支持捕鱼平台
      let filterList = state.platformList.filter(platform => platform.isSupportFish === 1 && platform.isShowGame === 1);

      let newList = filterList.sort((a, b) => { return a.fishOrderNum - b.fishOrderNum })
      // if (newList.length % 2 != 0) {
      //   newList.push({ platformCode: 'developing' })
      // }
      return newList
    },
    getPlatformByCode: (state) => (platformCode) => {
      //根据code 获取平台
      return state.platformList.find(todo => todo.platformCode === platformCode)
    },
    //真人游戏大厅列表
    getRealmanCode: (state) => {
      let ag = [];
      let ds = [];
      ag = state.realmanHallList.filter(e => e.platformCode == 'AG')
      ds = state.realmanHallList.filter(e => e.platformCode == 'DS')
      return [...ag, ...ds]
    },
  }
}